import React from 'react';

export default (props) => {
  return (
    <React.Fragment>

      <h1 className="page-title">Accessibility statement</h1>
      <p>Slough MyScan is provided to you by Slough Borough Council and has been developed by Looking Local. It is
        designed to be used by as many people as possible. The text should be clear and simple to understand. You should
        be able to:</p>
      <ul>
        <li>
          <p>zoom in up to 300% without the text spilling off the screen</p>
        </li>
        <li>
          <p>navigate most of the web app using just a keyboard</p>
        </li>
        <li>
          <p>navigate most of the web app using speech recognition software</p>
        </li>
        <li>
          <p>listen to most of the web app using a screen reader (including the most recent versions of JAWS, NVDA and
            VoiceOver)</p>
        </li>
      </ul>
      <p><a href="https://mcmw.abilitynet.org.uk/">AbilityNet </a>has advice on making your device easier to use if you
        have a disability.</p>
      <h2>How accessible this web app is</h2><p>Parts of this web app are not fully accessible. For
      example:</p>
      <ul>
        <li>
          <p>some form elements are not correctly identified</p>
        </li>
      </ul>
      <h2>How to request content in an accessible format</h2><p>If you need information on this web app in
      a different format <a href="https://slough.scanstation.lookinglocal.gov.uk/#/contacts">contact us</a> and tell
      us:</p>
      <ul>
        <li>
          <p>the web address (URL) of the content</p>
        </li>
        <li>
          <p>your name and email address</p>
        </li>
        <li>
          <p>the format you need. For example: audio CD, braille, BSL or large print, accessible PDF</p>
        </li>
      </ul>
      <h2>Reporting accessibility problems with this web app</h2><p>If you find any problems that are not
      listed on this page or you think we&rsquo;re not meeting the accessibility requirements, <a
        href="https://slough.scanstation.lookinglocal.gov.uk/#/contacts">contact us</a> and tell us:</p>
      <ul>
        <li>
          <p>the web address (URL) and location of any non-compliant content</p>
        </li>
        <li>
          <p>your name and email address</p>
        </li>
      </ul>
      <h2>Enforcement procedure</h2><p>If you contact us with a complaint and you&rsquo;re not happy with
      our response contact the Equality Advisory and Support Service.</p>
      <p>The Equality and Human Rights Commission (EHRC) is responsible for enforcing the Public Sector Bodies (Websites
        and Mobile Applications) (No. 2) Accessibility Regulations 2018 (the &lsquo;accessibility
        regulations&rsquo;).</p>
      <h2>Technical information about this web app's accessibility</h2><p>Slough Borough Council and
      Looking Local are committed to making this web app accessible, in accordance with the Public Sector Bodies
      (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018.</p>
      <p>This web app is partially compliant with the <a href="https://www.w3.org/TR/WCAG21/">Web Content Accessibility
        Guidelines version 2.1</a> AA standard.</p>
      <h2>Non-accessible content</h2><p>The content that is not accessible is outlined below:</p>
      <ol>
        <li>
          <p>Some form elements on the submission page do not have a label, which affects how they work with assistive
            technology. This fails WCAG 2.1 success criterion 1.3.1, 3.3.2 (Name, Role, Value).</p>
        </li>
      </ol>
      <h2>Disproportionate burden</h2><p>Not applicable.</p>
      <h2>Content that&rsquo;s not within the scope of the accessibility regulations</h2><p>Not applicable.
    </p>
      <h2>How we tested this web app</h2><p>This web app was last tested for compliance with the Web
      Content Accessibility Guidelines (version 2.1) level AA on 5 October 2022. The test was carried out internally by
      Looking Local.</p>
      <p>Looking Local used an automated testing tool <a
        href="https://accessibilityinsights.io/docs/en/web/overview#what-s-accessibility-insights-for-web">Accessibility
        Insights for Web</a> to test a subset of web pages, ensuring all the main areas of the web app were included in
        the sample. The results were recorded and accessibility issues discovered have been added to the accessibility
        roadmap.</p>
      <p>Looking Local tested the MyScan web app, available at <a
        href="https://slough.scanstation.lookinglocal.gov.uk/#/home">https://slough.scanstation.lookinglocal.gov.uk/#/home</a>
      </p>
      <h2>What we&rsquo;re doing to improve accessibility</h2><p>We conduct periodic accessibility testing
      and fix content which fails to meet the Web Content Accessibility Guidelines version 2.1 AA standard (as long as
      it falls under our control). We will also fix accessibility issues (under our control) reported to us by service
      users. We will update this page when issues are fixed.</p>
      <p>This statement was prepared on 28 April 2021. It was last updated on 5 October 2022.</p>
    </React.Fragment>

  );
}
